import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'
import withMixpanel, { SCREEN_VIEW_ORGANISATION_OVERVIEW } from 'utils/mixpanel'

import * as dataModule from 'modules/data'
import * as userActions from 'actions/userActions'
import * as routeActions from 'actions/routeActions'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.user) || null,
        organisation: idx(state, _ => _.organisation.selected),
        overviewData: idx(state, _ => _.data.overviewData),
        hidePlaceholder: idx(state, _ => _.data.overviewData.organisationOverviewDetails.some(item => item.totalTraps > 0 || item.totalKills > 0))
      }
    },
    (dispatch) => {
      const actions = {
        ...dataModule,
        ...userActions,
        ...routeActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  lifecycle({
    componentDidMount() {
      const { track, actions, organisation } = this.props

      actions.getOverviewData(organisation)
      track(SCREEN_VIEW_ORGANISATION_OVERVIEW)
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/organisation/Overview/Overview.enhancer.js